import merge from "lodash/merge";
import italianMessages from "ra-language-italian";
import {
    InstallationEventStatus,
    InstallationsGroupStatuses,
    TicketEventStatus
} from "../common/statuses";

export default merge(italianMessages, {
    ra: {
        auth: {
            logout: "Logout",
            pwd_forgot: "Password dimenticata",
            user_menu: "Apri"
        },
        actions: {
            select: "Seleziona",
            delete: "Cancella",
            remove: "Rimuovi",
            confirm: "Conferma",
            cancel: "Annulla",
            close: "Chiudi",
            forward: "Avanti",
            deleteSelectedResource: "Confermare l'operazione?",
            changePassword: "Cambiare la password",
            disable: "Disabilita",
            wait: "L’operazione potrebbe richiedere alcuni minuti",
            ok: "OK"
        },
        action: { search: "Cerca" },
        navigation: {
            page_rows_per_page: "Righe per pagina"
        }
    },

    resources: {
        customers: {
            name: "Cliente |||| Clienti",
            nameSingular: "Cliente",
            namePlural: "Clienti",
            fields: {
                vatin: "Partita iva / Codice Fiscale",
                name: "Cliente",
                email: "Email",
                active_installations: "Installazioni attive",
                booked_installations: "Installazioni prenotate",
                total_active_installations: "Installazioni attive",
                total_licensed_installations: "Installazioni prenotate",
                company_ids: "Aziende collegate",
                company_name: "Azienda"
            },
            views: {
                list: {
                    title: "Elenco clienti"
                }
            },
            actions: {
                export: {
                    confirm:
                        "Verranno esportati solo i clienti con installazioni attive. Riceverai una mail con il csv non appena sarà generato.",
                    export_short: "Esporta"
                },
                enable: "Abilita",
                enabled: "Riattivato cliente",
                errorEnabled: "Il cliente non può essere riattivato",
                delete: "Cancella",
                associate: {
                    yes: "Si",
                    no: "No",
                    cancel: "Cancel",
                    title: "Partita Iva già censita! ",
                    content: "Collegare il cliente alla azienda di login?",
                    content_warning: `Il cliente è già collegato alla azienda di login!`
                }
            },
            validation: {
                notSpecialCharacter:
                    "Non deve contenere caratteri speciali o spazi",
                checkVatin:
                    "Partita iva non deve contenere caratteri speciali o spazi",
                existingDisabled:
                    "Cliente già presente, ma disabilitato. Contattare l'amministratore per riattivarlo",
                piva_already_exists: "Partita Iva già censita! "
            }
        },
        users: {
            name: "Utente |||| Utenti",
            nameSingular: "Utente",
            namePlural: "Utenti",
            errorPasswordDoesntMatch: "Le password non coincidono",
            errorPasswordEqualToUsername:
                "La Password deve essere differente dal nome utente",
            fields: {
                username: "Nome utente",
                password: "Password",
                password_confirm: "Conferma Password",
                new_password: "Nuova Password",
                name: "Nome",
                surname: "Cognome",
                company_ids: "Aziende collegate",
                company_name: "Azienda"
            },
            views: {
                list: {
                    title: "Elenco utenti"
                }
            },
            actions: {
                enable: "Abilita",
                enabled: "Riattivato utente",
                errorEnabled: "L'utente non può essere riattivato",
                disable: "Disabilita",
                delete: "Cancella",
                reset: "Reimpostare la password",
                resend_activation_link: "Invio link di attiviazione",
                activation_link_sent:
                    "Link di attivazione inviato all'email dell'utente.",
                activation_link_error:
                    "Non è`stato possibilie inviare il link di attivazione",
                reset_link_sent:
                    "Richiesto cambio password. Una mail con il link per reimpostare la password è stata inviata all'indirizzo associato all'account dell'utente",
                reset_link_error:
                    "Non è stato possibile richiedere il cambio password",
                errorReset: "La password non è stata reimpostata"
            }
        },
        notifications: {
            name: "Notifiche |||| Notifiche",
            nameSingular: "Notifica da TeamSystem Cloud Console",
            namePlural: "Notifiche",
            fields: {
                text: "Scrivi messaggio"
            },
            views: {
                list: {
                    title: "Notifiche"
                }
            }
        },
        companies: {
            name: "Azienda |||| Aziende",
            nameSingular: "Azienda",
            namePlural: "Aziende",
            errorCompaniesRequired: "Selezionare almeno un'azienda",
            fields: {
                vatin: "Partita iva",
                name: "Ragione sociale",
                role: "Ruolo",
                seller_code: "Codice rivenditore",
                master_company_id: "Rivenditore principale",
                code: "UUID BBS",
                numeric_id: "ID BBS"
            },
            views: {
                list: {
                    title: "Elenco aziende"
                }
            },
            actions: {
                selectLoginCompany:
                    "Seleziona l'azienda con cui effettuare l'accesso",
                loadingCompanies: "Ricerca aziende...",
                selectCompany: "Continua",
                selectCompanyToAdd: "Seleziona l'azienda da aggiungere",
                companyResultsFor: "Risultati per la P. Iva",
                noCompanyFound:
                    "Nessuna azienda trovata per questa Partita IVA",
                failedToContactService:
                    "Errore durante la chiamata al servizio di ricerca azienda.",
                delete: "Cancella",
                disable: "Disabilita",
                enable: "Abilita",
                enabled: "Riattivata azienda",
                errorEnabled: "L'azienda non può essere riattivata"
            },
            type: {
                master: "Azienda master",
                controlled: "Azienda controllata"
            },
            validation: {
                notSpecialCharacter:
                    "Non deve contenere caratteri speciali o spazi",
                checkVatin:
                    "Partita iva non deve contenere caratteri speciali o spazi",
                existingDisabled:
                    "Azienda già presente, ma disabilitata. Contattare l'amministratore per riattivarla"
            }
        },
        utilities: {
            name: "Utilità |||| Utilità",
            nameSingular: "Utilità",
            namePlural: "Utilità",
            fields: {
                //name: "log"
            },
            actions: {
                download_ongoing: "Download in corso...",
                download_completed: "Download completato",
                download_failed: "Download fallito",
                get_file: "Salva in..."
            }
        },
        installations: {
            name: "Installazione |||| Installazioni",
            nameSingular: "Installazione",
            namePlural: "Installazioni",
            fields: {
                product_environment: "Ambiente",
                product_version: "Versione",
                access_url: "Url accesso",
                complete_installation_url: "Url accesso completo",
                status: "Stato",
                plan_user_count: "Numero utenti offerta",
                last_updated_at: "Ultimo update",
                company_id: "Azienda",
                // last_backedup_at: "Ultimo backup" Substituted with label below
                last_backedup_at: "Timestamp",
                customer_name: "Cliente",
                company_name: "Azienda",
                admin_password: "Password admin",
                admin_l2_password: "Password admin L2",
                installation_type_id: "Tipo",
                disabled_at: "Data cancellazione",
                advanced: "Funzioni Avanzate",
                motivation: "Motivazione"
            },
            views: {
                list: {
                    title: "Elenco installazioni"
                }
            },
            filters: {
                show_failed_installations: "Mostra anche installazioni fallite"
            },
            actions: {
                backup: "Esegui backup",
                enable: "Annulla disdetta",
                enabledDisdetta: "Disdetta annullata",
                update: "Aggiorna",
                reboot: "Riavvia il container",
                loginAsAdmin: "Accedi come admin",
                replayProvisioning: "Ripeti provisioning",
                provisioningCommandSent: "Comando inviato",
                provisioningCommandError:
                    "Non è stato possibile eseguire l'operazione",
                redo_provisioning_message: "Provisioning riavviato manualmente",
                disable:
                    "Vuoi prenotare la cancellazione di questa installazione?",
                delete_anyway:
                    "ATTENZIONE: Questa operazione elimina l'installazione. Vuoi continuare?",
                force_delete: "Forza cancellazione",
                force_delete_warning:
                    "ATTENZIONE: Questa operazione elimina in modo forzato l'installazione. Vuoi continuare?",
                force_delete_started: "Disinstallazione forzata avviata",
                tcc_delete: "Elimina in console",
                tcc_delete_started: "Cancellazione in console avviata",
                tcc_delete_warning:
                    "ATTENZIONE: Questa operazione elimina l'installazione solo nella Console, assicurarsi di rimuovere le risorse nel cloud. Vuoi continuare?",
                disdetta_cancel:
                    "ATTENZIONE: Questa operazione annulla la prenotazione di cancellazione. Vuoi continuare?",
                export: {
                    confirm:
                        "Verranno esportate tutte le installazioni. Riceverai una mail con il csv non appena sarà generato.",
                    export_short: "Esporta"
                },
                unlocked: "Installazione sbloccata",
                locked: "Installazione bloccata",
                lock: "Blocca",
                unlock: "Sblocca",
                forceSucceeded: "Forza completamento",
                forceSucceededFailed: "Impossibile forzare il completamento",
                forcedProvisioningSucceeded:
                    "Completamento forzato con successo",
                errorUnlock: "Impossibile sbloccare l'installazione",
                forceError: "Forza errore",
                forceErrorFailed: "Impossibile forzare errore",
                forcedErrorSucceeded: "Errore forzato con successo",
                force_error_warning:
                    "ATTENZIONE: Questa operazione forzerà uno stato di errore sul provisioning. Usare solo se necessario. Vuoi continuare?",
                errorLock: "Impossibile bloccare l'installazione",
                customer_transfer: "Voltura",
                url_transfer: "Modifica Access URL",
                ticket: "Vai al ticket",
                advanced: "Avanzate",
                company_modify: "Cambia azienda",
                stop_operation: "Chiudi operazione",
                stopOperationFailed: "Impossibile chiudere operazione",
                stopOperationSucceeded: "Operazione chiusa con successo",
                stop_operation_warning:
                    "ATTENZIONE: Questa funzione chiuderà in modo forzato le operazioni in corso. Usare solo in caso di operazioni in stallo. Vuoi continuare?",
                start_operation: "Operazione avviata",
                downloadBackup: "Scarica backup",
                download_backup_date_label: "Data del backup",
                download_backup_success:
                    "Richiesta inviata. Riceverai via e-mail il link per scaricare il backup.",
                download_backup_error:
                    "Errore durante l'invio della richiesta di scaricamento backup."
            },
            groupStatuses: {
                [InstallationsGroupStatuses.allInstallations]: "TUTTE",
                [InstallationsGroupStatuses.inProgressAndCompletedInstallations]:
                    "IN CORSO e COMPLETATE",
                [InstallationsGroupStatuses.inProgressInstallations]:
                    "IN CORSO",
                [InstallationsGroupStatuses.completedInstallations]:
                    "COMPLETATE",
                [InstallationsGroupStatuses.failedInstallations]: "FALLITE",
                [InstallationsGroupStatuses.pendingDelete]:
                    "IN ATTESA DI CANCELLAZIONE"
            }
        },
        installation_types: {
            name: "Tipo installazione |||| Tipi installazione",
            nameSingular: "Tipo installazione",
            namePlural: "Tipi installazioni",
            fields: {
                name: "Tipo",
                codename: "Codice",
                licence: "Licenza",
                max_pdl: "Postazioni di lavoro",
                flg_locked: "Bloccata",
                service_users: "Utenti delle utenze di servizio",
                documentation_url: "URL docuemntazione",
                doc_image_url: "URL immagine documentazione",
                migration_tool_url: "URL tool di migrazione",
                migration_tool_img_url: "URL immagine tool di migrazione",
                notifications: "Notifiche"
            },
            views: {
                list: {
                    title: "Elenco tipi installazione"
                }
            },
            types: {
                ENTERPRISE: "ENTERPRISE",
                STUDIO: "STUDIO"
            },
            url_pattern: {
                STUDIO: `Solo lettere minuscole e cifre. E' ammesso il carattere '-' ma non come carattere iniziale e finale"`,
                ENTERPRISE: `Solo lettere minuscole e cifre`
            }
        },
        events: {
            name: "Evento |||| Eventi",
            nameSingular: "Evento",
            namePlural: "Eventi",
            fields: {
                type: "Tipo",
                message: "Descrizione",
                created_at: "Data e ora",
                progress_status: "Avanzamento"
            },
            types: {
                [InstallationEventStatus.InstallationStarted]:
                    "INSTALLAZIONE AVVIATA",
                [InstallationEventStatus.localMigrationStarted]:
                    "MIGRAZIONE LOCALE AVVIATA",
                [InstallationEventStatus.localMigrationFailed]:
                    "MIGRAZIONE LOCALE FALLITA",
                [InstallationEventStatus.localMigrationSucceeded]:
                    "MIGRAZIONE LOCALE EFFETTUATA",

                [InstallationEventStatus.compressionStarted]:
                    "COMPRESSIONE AVVIATA",
                [InstallationEventStatus.compressionFailed]:
                    "COMPRESSIONE FALLITA",
                [InstallationEventStatus.compressionSucceeded]:
                    "COMPRESSIONE EFFETTUATA",

                [InstallationEventStatus.backupUploadStarted]:
                    "UPLOAD DEL BACKUP AVVIATO",
                [InstallationEventStatus.backupUploadSucceeded]:
                    "UPLOAD DEL BACKUP COMPLETATO",
                [InstallationEventStatus.backupUploadFailed]:
                    "UPLOAD DEL BACKUP FALLITO",

                [InstallationEventStatus.provisioningRestarted]:
                    "PROVISIONING RIAVVIATO",
                [InstallationEventStatus.provisioningStarted]:
                    "PROVISIONING AVVIATO",
                [InstallationEventStatus.provisioningFailed]:
                    "PROVISIONING FALLITO",
                [InstallationEventStatus.provisioningRunning]:
                    "PROVISIONING IN ESECUZIONE",
                [InstallationEventStatus.provisioningSucceeded]:
                    "PROVISIONING EFFETTUATO",
                [InstallationEventStatus.confirmationEmailSent]:
                    "EMAIL DI CONFERMA INVIATA",
                [InstallationEventStatus.onPremise]: "ON PREMISE",
                [InstallationEventStatus.pendingDelete]:
                    "IN ATTESA DI CANCELLAZIONE",
                [InstallationEventStatus.removesPendingDelete]:
                    "RIMOSSA LA PRENOTAZIONE CANCELLAZIONE",
                [InstallationEventStatus.uninstallationStarted]:
                    "DISINSTALLAZIONE AVVIATA",
                [InstallationEventStatus.uninstallationRunning]:
                    "DISINSTALLAZIONE IN CORSO",
                [InstallationEventStatus.failedToStartUninstall]:
                    "IMPOSSIBILE AVVIARE LA DISINSTALLAZIONE",
                [InstallationEventStatus.uninstallationFailed]:
                    "DISINSTALLAZIONE FALLITA",
                [InstallationEventStatus.uninstallationSucceeded]:
                    "DISINSTALLAZIONE TERMINATA",
                [InstallationEventStatus.UpdateStarted]:
                    "AGGIORNAMENTO IN CORSO",
                [InstallationEventStatus.FailedToStartUpdate]:
                    "IMPOSSIBILE AVVIARE L'AGGIORNAMENTO",
                [InstallationEventStatus.UpdateFailed]: "AGGIORNAMENTO FALLITO",
                [InstallationEventStatus.UpdateSucceeded]:
                    "AGGIORNAMENTO EFFETTUATO",
                [InstallationEventStatus.RetentionUninstallFailed]:
                    "DISINSTALLAZIONE FALLITA",
                [InstallationEventStatus.RetentionUninstallSucceeded]:
                    "DISINSTALLAZIONE TERMINATA",
                [InstallationEventStatus.RetentionUninstallStarted]:
                    "DISINSTALLAZIONE AVVIATA",
                [InstallationEventStatus.RetentionFailed]:
                    "DISINSTALLAZIONE FALLITA",
                [InstallationEventStatus.RetentionSucceeded]:
                    "DISINSTALLAZIONE TERMINATA",
                [InstallationEventStatus.RetentionStarted]:
                    "DISINSTALLAZIONE AVVIATA"
            }
        },
        email: {
            actions: {
                sendMail: "Invia mail",
                errorMail: "Errore nell'invio e-mail",
                mailSent: "E-mail inviata!"
            }
        },
        notification: {
            actions: {
                resetNotification: "Rimuovi notifica cancellazione",
                errorResetNotification:
                    "Errore in cancellazione notifica. Riprova",
                notificationResetSent:
                    "Cancellazione notifica avvenuta correttamente!",
                notificationNewSent: "Notifica impostata correttamente!",
                newNotification: "Imposta notifica cancellazione"
            }
        },
        operations: {
            name: "Operazione |||| Operazioni",
            nameSingular: "Operazione",
            namePlural: "Operazioni",
            views: {
                list: {
                    title: "Elenco operazioni"
                }
            },
            actions: {
                delete: "Cancella"
            },
            fields: {
                installation_type_id: "Tipo installazione",
                name: "Nome",
                operation_type_id: "Tipo",
                start_event: "Evento di avvio",
                succeeded_event: "Evento di successo",
                failed_events: "Eventi di errore",
                url: "URL",
                type: "Metodo HTTP",
                params: "Parametri",
                authcode: "Autenticazione",
                region: "Regione AWS",
                service: "Servizio AWS",
                flg_save_param_values: "Salva parametri"
            }
        },
        roles: {
            name: "Ruolo |||| Ruoli",
            nameSingular: "Ruolo",
            namePlural: "Ruoli",
            fields: {
                name: "Nome",
                description: "Descrizione",
                admin_console_plus: "Amministratore console +"
            },
            admin_ts_var: "Amministratore azienda",
            admin_console: "Amministratore console",
            admin_console_plus: "Amministratore console +",
            user_ts_var: "Operatore",
            watcher_console: "Osservatore console",
            watcher: "Osservatore",
            company_trigger: "Attivatore azienda",
            assistance: "Assistena"
        },
        "role-mappings": {
            name: "Ruoli",
            namePlural: "Ruoli",
            views: {
                list: {
                    title: "Elenco ruoli"
                }
            },
            fields: {
                company_id: "Azienda",
                user_id: "Utente",
                role_id: "Ruolo"
            },
            filters: {
                company: "Azienda",
                username: "Nome utente",
                role: "Ruolo"
            }
        },
        "customers-mappings": {
            name: "Cliente-Azienda |||| Clienti-Azienda",
            nameSingular: "Cliente-Azienda",
            namePlural: "Clienti-Azienda",
            fields: {
                name: "Cliente",
                active_installations: "Installazioni attive",
                booked_installations: "Installazioni prenotate",
                company_name: "Azienda"
            },
            views: {
                list: {
                    title: "Elenco clienti-azienda"
                }
            }
        },
        tickets: {
            name: "Ticket |||| Ticket",
            nameSingular: "Ticket",
            namePlural: "Ticket",
            views: {
                list: {
                    title: "Elenco ticket"
                }
            },
            fields: {
                installation_type_id: "Tipo",
                company_id: "Azienda",
                user_id: "Assegnatario",
                customer_id: "Cliente",
                installation_id: "Installazione",
                status: "Stato",
                note: "Nota",
                created_at: "Creazione",
                assigned_at: "Presa in carico",
                last_updated_status_at: "Ultima mod. stato",
                order_code: "Cod. ordine",
                pdl: "Postazioni di lavoro",
                activity: "Attività"
            },
            status: {
                [TicketEventStatus.all]: "TUTTI",
                [TicketEventStatus.ticketTobeAssignedOrInPRogress]:
                    "DA ASSEGNARE e IN CORSO",
                [TicketEventStatus.ticketToDo]: "DA ASSEGNARE",
                [TicketEventStatus.ticketInProgress]: "IN CORSO",
                [TicketEventStatus.ticketDone]: "COMPLETATO"
            },
            actions: {
                remove_owner: "Rimuovi assegnatario",
                assign_to_me: "Assegna a me",
                confirm_remove_owner:
                    "Confermare di voler rimuovere l'assegnatario?",
                edit_ticket: "Gestisci",
                create_installation: {
                    create: "Crea installazione",
                    create_short: "Crea",
                    continue: "Continua",
                    confirm:
                        "Confermare di voler creare una nuova installazione cloud?"
                },
                check_license: "Verifica licenza"
            },
            activity_decoder: {
                INSTALLATION: "Nuova installazione",
                MIGRATION: "Migrazione"
            }
        },
        configs: {
            name: "Impostazioni |||| Impostazioni",
            nameSingular: "Impostazioni",
            namePlural: "Impostazioni",
            fields: {
                enterprise_lock: "ENTERPRISE",
                studio_lock: "STUDIO/AZIENDA/HR",
                portal_lock: "Portale"
            },
            labels: {
                maintenanceLock: "Blocco operatività per manutenzione:"
            },
            views: {
                list: {
                    title: "Impostazioni"
                }
            }
        },
        profile: {
            name: "Profilo |||| Profilo",
            nameSingular: "Profilo",
            namePlural: "Profilo",
            views: {
                list: {
                    title: "Profilo"
                }
            }
        },
        configdatabase: {
            name: "Database |||| Database",
            nameSingular: "Database",
            namePlural: "Database",
            fields: {
                // aggiungi qui eventuali campi se necessario
            },
            views: {
                list: {
                    title: "Elenco tabelle"
                }
            }
        },
        roleswitching: {
            name: "Cambio Ruolo |||| Cambio Ruolo",
            nameSingular: "Cambio Ruolo",
            namePlural: "Cambio Ruolo",
            fields: {
                // aggiungi qui eventuali campi se necessario
            },
            actions: {
                switch_on: "Avvia Cambio Ruolo",
                switch_off: "Ferma Cambio Ruolo"
            },
            messages: {
                real_role_info: '— il tuo ruolo reale è "%{realRole}"'
            }
        },
        logs: {
            namePlural: "Logs",
            tabs: {
                http: "Log HTTP",
                db: "Log DB",
                config: "Configurazione"
            },
            fields: {
                timestamp: "Timestamp",
                level: "Livello",
                message: "Messaggio",
                meta: "Meta",
                id: "ID",
                installation_id: "Installazione",
                created_at: "Data/ora",
                logs: "Log applicativo"
            },
            filters: {
                date: "Data",
                fromTime: "Ora da",
                toTime: "Ora a",
                text: "Cerca testo",
                installationId: "Installation ID",
                method: "Metodo",
                allMethods: "Tutti"
            },
            actions: {
                search: "Cerca",
                refresh: "Aggiorna",
                expand: "Espandi",
                collapse: "Comprimi"
            },
            messages: {
                noData: "Nessun log trovato per i filtri selezionati",
                loading: "Caricamento in corso...",
                error: "Errore nel caricamento dei log",
                noFileForDate:
                    "Nessun file di log disponibile per la data selezionata"
            },
            config: {
                fields: {
                    logHttpBody: "Log body request",
                    logHttpQuery: "Log query params",
                    logIgnoredRoutes: "Route ignorate",
                    logBodyBlacklist: "Campi del body da oscurare"
                },
                helpers: {
                    logHttpBody:
                        "Abilitare solo in ambienti non-produzione per evitare di loggare dati sensibili.",
                    logBodyBlacklist:
                        "I campi elencati vengono sempre oscurati nei log, anche quando 'Log body request' è disattivato."
                },
                chipPlaceholder: {
                    routes: "Aggiungi una route e premi Invio",
                    bodyKeys: "Aggiungi un nome campo e premi Invio"
                },
                actions: {
                    save: "Salva",
                    cancel: "Annulla",
                    addChip: "Aggiungi"
                },
                messages: {
                    loadError:
                        "Errore nel caricamento della configurazione log",
                    saveSuccess:
                        "Modifiche salvate. Saranno completamente attive entro 10 secondi.",
                    saveError: "Errore nel salvataggio della configurazione log"
                },
                dialogs: {
                    confirmSave: {
                        title: "Conferma salvataggio",
                        text:
                            "Confermi il salvataggio della configurazione log?",
                        confirm: "Conferma",
                        cancel: "Annulla"
                    },
                    unsavedChanges: {
                        title: "Modifiche non salvate",
                        text:
                            "Le modifiche alla configurazione log non sono state salvate. Vuoi uscire senza salvare?",
                        leave: "Esci senza salvare",
                        stay: "Annulla"
                    }
                }
            }
        }
    },
    ENTERPRISE: "ENTERPRISE",
    validationRequired: "Campo obbligatorio",
    notificationSent: "Notifica inviata",
    notificationSentError: "Errore in invio notifica",
    insert_user_credentials: "Inserire i dati per l'accesso",
    "Not Found": "Risorsa non trovata",
    "Service Unavailable": "Servizio non disponibile",
    Unauthorized: "Accesso negato",
    user_already_exists: "Utente già esistente, provare con un altro nome",
    user_already_exists_but_disabled:
        "Utente già esistente ma disabilitato. Contattare l'amministratore per attivarlo.",
    no_companies_to_login:
        "Nessuna azienda valida per effettuare il login. Contattare l'amministratore.",
    portal_down_for_maintenance:
        "Portale momentaneamente fuori servizio per manutenzione",
    portal_in_maintenance_migra_instal_not_allowed:
        "Portale in manutenzione - migrazioni ed installazioni non consentite",
    "Internal Server Error": "Errore del server",
    email_sent_success: "E-mail di conferma inviata",
    email_sent_error: "Errore nell'invio mail",
    "Unauthorized Method": "Operazione non consentita",
    "Forbidden Resource": "Risorsa non accessibile",
    "Invalid ticket - duplicated": "Ticket già presente",
    "Invalid ticket - Installation duplicated":
        "Ticket non valido - Installazione duplicata",
    no_permission:
        "Non hai i permessi necessari per eseguire l'operazione richiesta",
    file_not_found: "File non trovato",
    file_not_loaded: "File non caricato",
    file_loaded: "File caricato correttamente",
    file_name_error: "Nome file errato",
    customer_already_exists: "Cliente già esistente",
    customer_url_empty: "Inserire un URL per il Cliente",
    company_already_exists: "Azienda già esistente",
    newPassword: "Nuova password",
    confirmNewPassword: "Conferma nuova password",
    change: "Cambia",
    send: "Invia",
    "Captcha validation failed": "Captcha non verificato",
    "Inactive user, can't log in":
        "Il profilo è stato bloccato, contatta l'amministratore per la riattivazione",
    "Too much invalid login, Inactive user":
        "Hai superato il numero massimo di tentativi di accesso.\nIl tuo profilo è stato bloccato, contatta l'amministratore per la riattivazione",
    "User not found": "Utente non trovato",
    "Incorrect credential": "Credenziali errate",
    "Invalid order code - duplicated": "Codice d'ordine non valido - duplicato",
    "Invalid parent company": "Azienda proprietaria non valida",
    "Vatin must not contain special characters or spaces":
        "Partita iva non deve contenere caratteri speciali o spazi",
    "As an admin var you can only create companies from a master company":
        "Come amministratore puoi creare solo aziende da un'azienda master",
    "As an admin var you can only create controlled companies":
        "Come amministratore puoi creare solo aziende controllate",
    "As an admin var you can only set your company as main company":
        "Come amministratore var puoi solo impostare la tua azienda come azienda principale",
    "Company already exists":
        "Azienda già esistente o codice rivenditore già usato per questa azienda",
    "Customer already exists": "Cliente già esistente",
    "Unexpected event": "Evento inaspettato",
    "Portal in maintenance - migrations and installations not allowed":
        "Portale in manutenzione - migrazioni ed installazioni non consentite",
    "Installation can not be deleted": "Impossibile disinstallare",
    'Body validation failed - activity missing or not valid, "MIGRATION" required':
        'Convalida del corpo fallita - attività mancante o non valida, richiesta "MIGRAZIONE"',
    "Body validation failed - missing one value required, verify: customer_vatin, var_cod, var_vat, var_username, product_version, installation_type_id":
        "Convalida del corpo fallita - manca un valore richiesto, verifica: customer_vatin, var_cod, var_vat, var_username, product_version, installation_type_id",
    "Body validation failed - ticket id not valid":
        "Convalida del corpo fallita - id del ticket non valido",
    "Error: Body validation failed - invalid customer_url": "URL non valido",
    "Body validation failed - invalid customer_url": "URL non valido",
    "No mappings found in the system":
        "Nessuna mappatura dei ruoli trovata nel sistema",
    "Company id or user id or ids not provided":
        "Id azienda o id utente o entrambi non forniti",
    "No roles found in the system": "Nessun ruolo trovato nel sistema",
    "Ticket can not be deleted": "Il ticket non può essere cancellato",
    "Username must be a valid email":
        "Nome utente deve essere un indirizzo email valido",
    wrong_password_policy:
        "La Password deve essere composta da almeno 8 caratteri di cui almeno 1 maiuscola, 1 minuscola, 1 numero ed 1 carattere speciale tra (!@#$%^*_+=)",
    "Password must differ from username":
        "Password deve essere differente da Nome utente",
    invalid_password:
        "almeno 8 caratteri di cui 1 maiuscola, 1 minuscola, 1 numero e 1 carattere speciale (!@#$%^*_+=)",
    "User already exists": "Utente già esistente",
    "Conflict Customer name": "Conflitto in nome cliente",
    "All check OK": "Tutti i controlli sono corretti",
    "The user who made the request is not in the specified company":
        "L'utente che ha effettuato la richiesta non appartiene all'azienda specificata",
    "Missing 'user-company' header on request":
        "Azienda di login non selezionata",
    "Installation not found": "Installazione non trovata",
    "Ticket not found for installation id":
        "Ticket non trovato per l'installazione",
    "Ticket not found": "Ticket non trovato",
    "Recipient email address not found":
        "Indirizzo email del destinatario non trovato",
    "Email sent": "Email correttamente inviata",
    "All checks are okay": "Tutti i controlli sono corretti",
    "Validation failed. There should be a required property 'var_username'":
        "Validazione fallita. Proprietà 'var_username' mancante",
    "The user in the request cannot start the migration for the var/customer/installation_type_id provided":
        "L'utente specificato non può avviare la migrazione per var / customer / installation_type_id fornito",
    "Customer not found or not in the provided company":
        "Cliente non trovato nell'azienda specificata",
    "Customer disabled": "Cliente disabilitato",
    "Migrations limit reached for this customer/var":
        "limite delle migrazioni raggiunto per cliente / var",
    "no Master/Slave companies":
        "Modifica non consentita sono collegate aziende non controllate.",
    no_master_login_company:
        "Modifica non consentita effettuare l'accesso con l'azienda principale.",
    no_customer_update_role:
        "Modifica consentita solo a Amministratore di Azienda e amministratore di console.",
    no_customer_enabled_with_disabled_company:
        "Impossibile riabilitare il legame con azienda disabilitata",
    missing_licenses:
        "ATTENZIONE: Licenze mancanti, l'azienda non può gestire installazioni di nessun tipo",
    installation_type_studio: "STUDIO/AZIENDA/HR",
    installation_type_enterprise: "ENTERPRISE",
    mandatory_addressee_licenses:
        "Selezionare la tipologia di destinatario, il tipo di licenza e inserire il messaggio",
    notifactionSentError: "Errore nella spedizione",
    notifactionSent: "Notifica spedita",
    UNINSTALLATION_SUCCEEDED: "Disinstallazione effettuata",
    UNINSTALLATION_RUNNING: "Disinstallazione avviata",
    impossible_to_delete_user_because_his_tickets:
        "Non è possibile cancellare l'utente perché presenti dei ticket di sua competenza o da lui generati",
    to_delete_customer_disable_his_links_with_companies:
        "Per procedere deve essere disabilitato almeno un collegamento con azienda",
    to_delete_customer_remove_his_tickets:
        "Per procedere è necessario eliminare i ticket del cliente",
    to_delete_customer_remove_his_installations:
        "Per procedere è necessario eliminare le installazioni del cliente",
    to_delete_company_remove_his_tickets:
        "Per procedere è necessario eliminare i clienti dell'azienda",
    to_delete_company_remove_his_customers:
        "Per procedere è necessario eliminare i ticket dell'azienda",
    to_delete_company_remove_his_installations:
        "Per procedere è necessario eliminare le installazioni dell'azienda",
    to_delete_company_remove_his_users:
        "Per procedere è necessario rimuovere gli utenti dall'azienda",
    to_delete_company_remove_his_controlled_companies:
        "Per procedere è necessario rimuovere prima le aziende collegate",
    "Cannot delete last customer's mapping":
        "Un cliente deve avere almeno un collegamento con un'azienda, se il collegamento deve essere eliminato è possibile eliminare il cliente",
    // TODO - enterprise_in_maintenance_migra_instal_not_allowed:
    "Enterprise cloud in maintenance - migrations and installations not allowed":
        "Enterprise cloud in manutenzione - migrazioni ed installazioni non consentite",
    // TODO - enterprise_in_maintenance_migra_not_allowed:
    "Enterprise cloud in maintenance - migrations not allowed":
        "Enterprise cloud in manutenzione - migrazioni non consentite",
    // TODO -enterprise_in_maintenance_instal_not_allowed:
    "Enterprise cloud in maintenance - installations not allowed":
        "Enterprise cloud in manutenzione - installazioni non consentite",
    // TODO - enterprise_in_maintenance_uninstal_not_allowed:
    "Enterprise cloud in maintenance - uninstallations not allowed":
        "Enterprise cloud in manutenzione - disinstallazioni non consentite",
    // TODO - studio_in_maintenance_migra_instal_not_allowed:
    "Studio cloud in maintenance - migrations and installations not allowed":
        "Studio/Azienda cloud in manutenzione - migrazioni ed installazioni non consentite",
    // TODO - studio_in_maintenance_migra_not_allowed:
    "Studio cloud in maintenance - migrations not allowed":
        "Studio/Azienda cloud in manutenzione - migrazioni non consentite",
    // TODO - studio_in_maintenance_instal_not_allowed:
    "Studio cloud in maintenance - installations not allowed":
        "Studio/Azienda cloud in manutenzione - installazioni non consentite",
    // TODO - studio_in_maintenance_uninstal_not_allowed:
    "Studio cloud in maintenance - uninstallations not allowed":
        "Studio/Azienda cloud in manutenzione - disinstallazioni non consentite",
    "No license found": "Licenza non trovata o non valida",
    'To filter insert url except "https://" and ".cloudteamsys.com"': `Per filtrare inserire URL senza "https://" e ".cloudteamsys.com"`,
    'To filter insert url except "https://" and ".teamsystem.io"': `Per filtrare inserire URL senza "https://" e ".teamsystem.io"`,
    "Password doesn't meet requirements":
        "La password non soddisfa i requisiti",
    "New password must be differ from old one":
        "La password deve essere differente da quella attuale",
    "Password not accepted because same as user name":
        "La password deve essere differente dal nome utente",
    user_created:
        "Utente creato. La mail di attivazione è stata inviata all'indirizzo associato all'account",
    "Operation type not found": "Tipo operazione non trovato",
    "Another operation is still running for this installation":
        "Un'altra operazione è in corso per questa installazione",
    "The expected db parameters could not be found": "Parametri db non trovati",
    "Error communicating with cloud": "Errore di comunicazione con il cloud",
    "Update failed": "Aggiornamento fallito",
    "Provisioning failed": "Provisioning fallito",
    "Uninstallation failed": "Cancellazione fallita",
    "Unable to start uninstallation": "Impossibile avviare la disinstallazione",
    "Operation not available for installation":
        "Operazione non disponibile per l'installazione"
});



// WEBPACK FOOTER //
// ./src/messages/it.js